/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Broker_Offers_TitleInputs */

const cs_ebr_broker_offers_title = /** @type {(inputs: Ebr_Broker_Offers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky, které se propojí`)
};

const en_ebr_broker_offers_title = /** @type {(inputs: Ebr_Broker_Offers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers that will be linked`)
};

/**
* | output |
* | --- |
* | "Offers that will be linked" |
*
* @param {Ebr_Broker_Offers_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_broker_offers_title = /** @type {((inputs?: Ebr_Broker_Offers_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Broker_Offers_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_broker_offers_title(inputs)
	return cs_ebr_broker_offers_title(inputs)
});